import {Message} from './message.model';

export class InformationMessage extends Message {
    constructor(title: string, content?: string, path?: string, date?: string, link?: unknown, persistent: boolean = false) {
        super('information', '#Information', title, content, path, date, link, persistent);
    }
}
